import {injectable} from "inversify";
import Scene = Phaser.Scene;
import {LawPanel} from "@/scenes.ui/law-panel";
import PlayerStore from "@/store/player";
import {Markers} from "@/constants/marker";
import {PlayerMarker} from "@/store/player/types";
import {TenjinService} from "@/services/tenjin-service";
import {AppmetricaService} from "@/services/appmetrica-service";

@injectable()
export class LawService {

    private tenjinService!: TenjinService;
    private appmetricaService!: AppmetricaService;

    public async open(
        scene: Scene,
        canvas: HTMLCanvasElement,
        tenjinService: TenjinService,
        appmetricaService: AppmetricaService
    ) {

        this.appmetricaService = appmetricaService;
        await this.appmetricaService.activate();

        this.tenjinService = tenjinService
        this.tenjinService.initTenjin()
        // let cas = new (await import('@/cas')).CASService;
        if (this.haveMarker(Markers.CAS_SETTING_USER_CONSENT_STATUS_ACCEPT)) {
            // cas.initialize()
            // cas.validate()
            this.tenjinService.optIn()
            this.tenjinService.connectTenjin()
        }  else if (this.haveMarker(Markers.CAS_SETTING_USER_CONSENT_STATUS_DECLINE)) {
            // cas.initialize()
            // cas.validate()
            this.tenjinService.optOut()
            this.tenjinService.connectTenjin()
        }
        else {
            new LawPanel(scene, canvas, async () => {
                // cas.acceptLaw()
                // cas.initialize()
                // cas.validate()
                this.tenjinService.optIn()
                this.tenjinService.connectTenjin()
                PlayerStore.SET_MARKER(Markers.CAS_SETTING_USER_CONSENT_STATUS_ACCEPT);
                await PlayerStore.setMarker(Markers.CAS_SETTING_USER_CONSENT_STATUS_ACCEPT);
            }, async () => {
                // cas.declineLaw()
                // cas.initialize()
                // cas.validate()
                this.tenjinService.optOut()
                this.tenjinService.connectTenjin()
                PlayerStore.SET_MARKER(Markers.CAS_SETTING_USER_CONSENT_STATUS_DECLINE);
                await PlayerStore.setMarker(Markers.CAS_SETTING_USER_CONSENT_STATUS_DECLINE);
            }).open();
        }
    }

    private haveMarker(marker: String): Boolean {
        return PlayerStore.getPlayer()!.playerMarkers.some((m: PlayerMarker) => m.playerMarker == marker);
    }
}